'use client'

import React from 'react';

const SafetyStandard = () => {
  return (
    <div className="relative mx-auto max-w-screen-2xl py-6 px-3 sm:px-10" style={{ marginTop: '-7px' }}>
      <div className="mb-10 flex justify-left">
        <div className="text-left w-full lg:w-4/5">
          <h2 style={{
                fontSize: '1.4rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                 marginBottom: '20px'
              }} className="text-xl lg:text-2xl mb-2 font-serif font-semibold" >Home Saloon Safety Standards</h2>
        </div>
      </div>

      <div  className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-4 mt-[-40px]">
        {/* Sanitized & Safe Locations Card */}
        <div className="border border-gray-300 p-4 rounded-lg bg-white shadow-md">
          <div className="mb-4 flex justify-center">
            <svg
              stroke="currentColor"
              fill="none"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="flex-shrink-0 h-8 w-8 text-yellow-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="1" y="3" width="15" height="13"></rect>
              <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
              <circle cx="5.5" cy="18.5" r="2.5"></circle>
              <circle cx="18.5" cy="18.5" r="2.5"></circle>
            </svg>
          </div>
          <span style={{
                fontSize: '1rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                lineHeight: '1.5',
                textAlign: 'center', /* Center the text inside the block */
                margin: '0 0 10px',
              }}
              // className="text-base leading-6 text-justify justify-center"
              
              className="block font-sans text-sm font-medium text-center">
            Sanitized & Safe Locations
          </span>
        </div>

        {/* Verification on Priority Card */}
        <div className="border border-gray-300 p-4 rounded-lg bg-white shadow-md">
          <div className="mb-4 flex justify-center">
            <svg
              stroke="currentColor"
              fill="none"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="flex-shrink-0 h-8 w-8 text-yellow-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
              ></path>
            </svg>
          </div>
          <span  style={{
                fontSize: '1rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                lineHeight: '1.5',
                textAlign: 'center', /* Center the text inside the block */
                margin: '0 0 10px',
              }}
              // className="text-base leading-6 text-justify justify-center"
              className="block font-sans text-sm font-medium text-center">
            Verification on Priority
          </span>
        </div>

        {/* No Contact Service Card */}
        <div className="border border-gray-300 p-4 rounded-lg bg-white shadow-md">
          <div className="mb-4 flex justify-center">
            <svg
              stroke="currentColor"
              fill="none"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="flex-shrink-0 h-8 w-8 text-yellow-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
              <line x1="1" y1="10" x2="23" y2="10"></line>
            </svg>
          </div>
          <span  style={{
                fontSize: '1rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                lineHeight: '1.5',
                textAlign: 'center', /* Center the text inside the block */
                margin: '0 0 10px',
              }}
              // className="text-base leading-6 text-justify justify-center"
              className="block font-sans text-sm font-medium text-center">
            No Contact Service
          </span>
        </div>

        {/* Get 10% More with Safety Card */}
        <div className="border border-gray-300 p-4 rounded-lg bg-white shadow-md">
          <div className="mb-4 flex justify-center">
            <svg
              stroke="currentColor"
              fill="none"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="flex-shrink-0 h-8 w-8 text-yellow-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polyline points="20 12 20 22 4 22 4 12"></polyline>
              <rect x="2" y="7" width="20" height="5"></rect>
              <line x1="12" y1="22" x2="12" y2="7"></line>
              <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
              <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
            </svg>
          </div>
          <span  style={{
                fontSize: '1rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                lineHeight: '1.5',
                textAlign: 'center', /* Center the text inside the block */
                margin: '0 0 10px',
              }}
              // className="text-base leading-6 text-justify justify-center"
              className="block font-sans text-sm font-medium text-center">
            Get 10% More with Safety
          </span>
        </div>
      </div>
    </div>
  );
};

export default SafetyStandard;
